/* eslint-disable react/no-unused-prop-types */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import { Button, Form } from 'react-bootstrap';
import useAuth from '../hooks/useAuth';
import LoginMsg from '../loginMsg';

function ForgetPasswordForm({ currentUserEmail }) {
  // State
  const { resetPassHandler } = useAuth();

  const [email, setEmail] = useState(currentUserEmail);

  const [showMsg, setShowMsg] = useState('');

  const [disabledSend, setDisabledSend] = useState(false);

  const resetPass = () => resetPassHandler(email, setShowMsg);

  // Handler
  const handleSubmit = (e) => {
    e.preventDefault();
    setDisabledSend(true);
    resetPass().then(() => {
      if (email) {
        toast.success(
          `На адресу ${email} буде надіслано електронний лист із посиланням для зміни пароля`,
          {
            theme: 'colored',
          },
        );
      }
    });
  };

  return (
    <Form className="mt-4" onSubmit={handleSubmit}>
      <Form.Group className="mb-3">
        <Form.Control
          placeholder="Email address"
          value={email}
          name="email"
          onChange={({ target }) => setEmail(target.value)}
          type="email"
        />
      </Form.Group>

      <Form.Group className="mb-3">
        <Button className="w-100" type="submit" disabled={disabledSend}>
          Надіслати посилання на отримання нового паролю
        </Button>
      </Form.Group>

      <Link className="fs--1 text-600" to="/authentication/card/register">
        Я не можу відновити свій обліковий запис за допомогою цієї сторінки
        <span className="d-inline-block ms-1"> &rarr;</span>
      </Link>
      <LoginMsg onClose={setShowMsg} msg={showMsg} />
    </Form>
  );
}

ForgetPasswordForm.propTypes = {
  currentUserEmail: PropTypes.string,
};

ForgetPasswordForm.defaultProps = { currentUserEmail: '' };

export default ForgetPasswordForm;
